import { t } from "i18next";
import React from "react";

export default function HTabeleProduct({ children, customClass }) {
  return (
    <>
      <thead className={customClass}>
        {children}
        <tr className="text-center">
          <th>{t("Id")}</th>
          <th> {t("image")}</th>
          <th>{t("name")} </th>
          <th>{t("desc")}</th>

          <th>{t("stock")}</th>
          <th> </th>
        </tr>
      </thead>
    </>
  );
}
